import { API_BASE_URL as API_URL } from '../config';

/**
 * Submit a support request. The API sends an email to the support team with
 * user id, tenant id, and the message. The recipient email is not exposed to the client.
 */
export async function submitSupportRequest(message) {
  const token = sessionStorage.getItem('signalcue_token');
  if (!token) throw new Error('Not authenticated');

  const response = await fetch(`${API_URL}/api/support`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ message }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to send support request');
  }

  return response.json();
}

export const supportService = {
  submitSupportRequest,
};
